// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.clingon",
    name: "Cling Wallet",
    homepage: "https://clingon.io",
    image_id: "2d8006c3-852b-458a-d6b0-916c5ba76800",
    app: {
        browser: "https://chrome.google.com/webstore/detail/cling-wallet/kppgpfphbmbcgeglphjnhnhibonmebkn?hl=ko",
        ios: "https://apps.apple.com/us/app/cling-wallet/id6443952504",
        android: "https://play.google.com/store/apps/details?id=com.carrieverse.cling.wallet&hl=en_US&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "cling://",
        universal: "https://cling.carrieverse.com/apple-app-site-association",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map